import DemoTerms from '@/components/TermsConditionsUi/DemoTerms.vue';
import WorldPlayTerms from '@/components/TermsConditionsUi/WorldPlayTerms.vue';

export const termsAndConditionsMap = new Map();

termsAndConditionsMap.set('mtn-ng-en', DemoTerms);
termsAndConditionsMap.set('ais-th', DemoTerms);
termsAndConditionsMap.set('demo-en', WorldPlayTerms);
termsAndConditionsMap.set('telkom-wp-za-en', WorldPlayTerms);
termsAndConditionsMap.set('mtn-wp-za-en', WorldPlayTerms);
termsAndConditionsMap.set('wp-za-en', WorldPlayTerms);